import { QUANTITY } from "@/schemas/question/quantity";
import { forwardRef } from "react";
import { ControllerRenderProps } from "react-hook-form";
import EnumSelect from "@/components/EnumSelect";

const QuantityTypeSelect = forwardRef<HTMLButtonElement, ControllerRenderProps>(
  (props, ref) => (
    <EnumSelect
      options={QUANTITY}
      translationKey="quantityTypes"
      {...props}
      ref={ref}
    />
  ),
);

export default QuantityTypeSelect;
